import { useState } from "react";
import { useSelector } from "react-redux";

import Posts from "./InvoiceBalance";
import Pagination from "../../../StyledComponents/Pagination";
import { BillingFooter, BillingFooterSpacer } from "../styles";

const InvoiceBalance = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const invoListDetails = useSelector((state) => state.Billing.InvoList);
  const pendingInvoices = invoListDetails.filter((row) => parseFloat(row.total_balance || 0) !== 0);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = pendingInvoices.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(pendingInvoices.length / postsPerPage);

  return (
    <>
      <Posts InvoiceList={currentPosts} />
      <BillingFooter>
        {currentPosts.length !== 0 && howManyPages > 1 ? (
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        ) : (
          <BillingFooterSpacer />
        )}
      </BillingFooter>
    </>
  );
};

export default InvoiceBalance;
